import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Transalation, V6OptionTranslation, V6OptionValueTranslation } from '../models';
import { ApiService } from './api.service';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})
export class V6translationService {
  options: V6OptionTranslation[] = [];
  optionValues: V6OptionValueTranslation[] = [];
  initData() {
    if ((this.options.length === 0) || (this.optionValues.length === 0) || 1 === 1) {
      //
      //
      let apiEndpoint = ConfigService.APIs.endPoints.V6TRANSLATIONS.GET_OPTIONS;
      ApiService.genericObservableGet(this.httpClient, apiEndpoint).subscribe((r) => {
        this.options = r.data;
      });

      apiEndpoint = ConfigService.APIs.endPoints.V6TRANSLATIONS.GET_OPTION_VALUES;
      ApiService.genericObservableGet(this.httpClient, apiEndpoint).subscribe((r) => {
        this.optionValues = r.data;
      });
    }

  }

  constructor(private httpClient: HttpClient) { }
  transalations: Array<Transalation> = [
    { kdText: 'Frame System', v6Text: 'Frame Type', field: 'STD_DR_Multi DO Frame systems' },
    { kdText: 'Door Type', v6Text: 'DrType', field: 'STD_DR DR Type' },
    { kdText: 'Handing', v6Text: 'Hand', field: 'Handing' },
    { kdText: 'Hinging', v6Text: 'Hinge', field: 'STD_DR Hinging' },
    { kdText: 'Locking', v6Text: 'Lock', field: 'STD_DR Locking' },
    { kdText: 'Hardware Finish', v6Text: 'Hardware Finish', field: 'Hardware Finish modified by bill' },
    { kdText: 'Exterior Finish', v6Text: 'Job/Exterior Finish', field: 'Exterior Finish-Modified by Amy' },
    { kdText: 'Push/Pull Finish', v6Text: 'PushPull Finish', field: 'All Push/Pull Finishs' },
    { kdText: '', v6Text: '', field: '' },
    { kdText: '', v6Text: '', field: '' },
    { kdText: '', v6Text: '', field: '' },
    { kdText: '', v6Text: '', field: '' },
    { kdText: '', v6Text: '', field: '' },
    { v6Text: '[COL:K:17 (17)]', field: '17 (Clear Class II)', kdText: '17 (Clear Class II)' },
    { v6Text: '[COL:K:29 (29)]', field: '29 (Black)', kdText: '29 (Black)' },
    { v6Text: '[COL:K:40 (40)]', field: '40 (Dark Bronze)', kdText: '40 (Dark Bronze)' }
  ];

  translateV6ToKD(fieldName: string) {
    const tr = this.transalations.find(x => x.field === fieldName);
    if (tr) {
      return tr.kdText;
    }
    else return fieldName;
  }
  translateKDToV6(fieldName: string, v6Code) {
    if (v6Code && v6Code.length > 0) return v6Code;
    else return fieldName;
    //const tr = this.transalations.find(x => x.field === fieldName);
    //if (tr) {
    //  return tr.v6Text;
    //}
    //else return fieldName;
  }

  //logic summary
  //1. search by product translation code.
  //2. if not found then find by *
  //if not found in 1 & 2 then show text received from v6
  //if found in either step 1 or step 2
  //if translated text is empty then hide option or attribute
  //else show the translated text

  translatOptionToKD(translationFamily: string, optionCode: string) {
    try {
      if (!(this.options && this.options.length > 0)) { }//load the transaltions
      //let tr = this.options.find(x => (x.optionApplicableProducts && x.optionApplicableProducts.indexOf(translationFamily) === 0) && x.optionCode.toLowerCase() === optionCode.toLowerCase());

      let tr1 = this.options.filter(x => (x.optionApplicableProducts && x.optionApplicableProducts.indexOf(translationFamily) > -1) && x.optionCode.toLowerCase() === optionCode.toLowerCase());
      let tr = null;
      for (let i = 0; i < tr1.length; i++) {
        let el = tr1[i];
        let aps = el.optionApplicableProducts.split('|');
        let apIndex = aps.findIndex(x => x === translationFamily);
        if (apIndex > -1) {
          tr = el;
          break;
        }
      }

      if (tr) {
        if (tr.optionTranslation.length === 0) { return 'dummy do not show'; }
        else { return tr.optionTranslation; }
      }
      else {
        tr = this.options.find(x => x.optionCode.toLowerCase() === optionCode.toLowerCase() && x.optionApplicableProducts === '*');
        if (tr) {
          if (tr.optionTranslation.length === 0) { return 'dummy do not show'; }
          else { return tr.optionTranslation; }
        }
        else { return optionCode; }
      }
    }
    catch (ex) {
      return optionCode;
    }
  }
  translatOptionValueToKD(translationFamily: string, optionCode: string, optionValueCode: string, defaultText: string) {
    try {
      let tr1 = this.optionValues.filter(x => x.optionCode.toLowerCase() === optionCode.toLowerCase() && x.optionValueCode === optionValueCode && (x.optionValueApplicableProducts && x.optionValueApplicableProducts.indexOf(translationFamily) > -1));
      let tr = null;
      for (let i = 0; i < tr1.length; i++) {
        let el = tr1[i];
        let aps = el.optionValueApplicableProducts.split('|');
        let apIndex = aps.findIndex(x => x === translationFamily);
        if (apIndex > -1) {
          tr = el;
          break;
        }
      }
      if (tr) {
        if (tr.optionValueTranslation.length === 0) { return 'dummy do not show'; }
        else { return tr.optionValueTranslation; }
      }
      else {
        tr = this.optionValues.find(x => x.optionCode.toLowerCase() === optionCode.toLowerCase() && x.optionValueCode === optionValueCode && x.optionValueApplicableProducts === '*');
        if (tr) {
          if (tr.optionValueTranslation.length === 0) { return 'dummy do not show'; }
          else { return tr.optionValueTranslation; }
        }
        else { return defaultText; }
      }

    }
    catch (ex) {
      return defaultText;
    }
  }

  //translatOptionToKD1(translationFamily: string, optionCode: string, product: string) {

  //  translationFamily = translationFamily + '*';
  //  let tr = this.trdc.find(x => x["V6 option code"] === optionCode && x["Apply to products(attribute)"].indexOf(translationFamily) > -1);
  //  if (tr) {
  //    if (tr["Attribute translation"].length === 0) { return 'dummy do not show'; }
  //    else { return tr["Attribute translation"]; }
  //  }
  //  else {
  //    tr = this.trdc.find(x => x["V6 option code"] === optionCode && x["Apply to products(attribute)"] === '*');
  //    if (tr) {
  //      if (tr["Attribute translation"].length === 0) { return 'dummy do not show'; }
  //      else { return tr["Attribute translation"]; }
  //    }
  //    else { return optionCode; }
  //  }
  //}


  //translatOptionValueToKD1(translationFamily: string, defaultText: string, optionCode: string, optionValueCode: string, product: string) {
  //  translationFamily = translationFamily + '*';
  //  let tr = this.trdc.find(x => x["V6 option code"] === optionCode && x["Attribute value code"] === optionValueCode && x["Apply to products(value)"].indexOf(translationFamily) > -1);
  //  if (tr) {
  //    if (tr["Attribute value translation"].length === 0) { return 'dummy do not show'; }
  //    else { return tr["Attribute value translation"]; }
  //  }
  //  else {
  //    tr = this.trdc.find(x => x["V6 option code"] === optionCode && x["Attribute value code"] === optionValueCode && x["Apply to products(value)"] === '*');
  //    if (tr) {
  //      if (tr["Attribute value translation"].length === 0) { return 'dummy do not show'; }
  //      else { return tr["Attribute value translation"]; }
  //    }
  //    else { return defaultText; }
  //  }
  //}


  ////#region data

  //public trdc = [
  //  {
  //    "V6 option code": "1stXRail",
  //    "Attribute translation": "1st Cross Rail",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "1stXRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "TSD_M001",
  //    "Attribute value translation": "1-3/8\" Cross Rail",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "1stXRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "TSD_M002",
  //    "Attribute value translation": "8-1/4\" Cross Rail",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "1stXRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "XR13",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "1stXRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "XR15C",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "1stXRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "XR16C",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "1stXRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "XR18",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "1stXRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "XR999",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "1stXRailLoc",
  //    "Attribute translation": "1st X-Rail Location(from Bottom of door to Top of X-Rail)",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "1stXRailLoc",
  //    "Attribute translation": "1st X-Rail Location(from Bottom of Track to C/L of X-Rail)",
  //    "Apply to products(attribute)": "990*|1010*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "2Lock_MSOptions",
  //    "Attribute translation": "2Lock_MSOptions",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "2Lock_MSOptions",
  //    "Attribute translation": "2 Lock MS Lock Type",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "2ndXRail",
  //    "Attribute translation": "2nd Cross Rail",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "2ndXRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "TSD_M001",
  //    "Attribute value translation": "1-3/8\" Cross Rail",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "2ndXRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "TSD_M002",
  //    "Attribute value translation": "8-1/4\" Cross Rail",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "2ndXRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "XR13",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "2ndXRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "XR15C",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "2ndXRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "XR16C",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "2ndXRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "XR18",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "2ndXRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "XR999",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "2ndXRailLoc",
  //    "Attribute translation": "2nd X-Rail Location(from Bottom of door to Top of X-Rail)",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "2ndXRailLoc",
  //    "Attribute translation": "2nd X-Rail Location(from Bottom of Track to C/L of X-Rail)",
  //    "Apply to products(attribute)": "990*|1010*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "350HWFrame",
  //    "Attribute translation": "Heavy Weight Framing",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "350HWHFrame",
  //    "Attribute translation": "Heavy Weight Frame",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "590300 Dim A",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "590300 Dim B",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "590301 Dim A",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "590301 Dim B",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "590302 Dim A",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "590302 Dim B",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "590302 Dim C",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "590303 Dim A",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "590303 Dim B",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "590303 Dim C",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "590304 Dim A",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "590304 Dim B",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "590305 Dim B",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "590305 Dim C",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "590306 Dim B",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "590306 Dim C",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "590307 Dim A",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "590307 Dim B",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "590307 Dim C",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "590307 Dim D",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "590308 Dim A",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "590308 Dim B",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "590308 Dim C",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "590308 Dim D",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "590309 Dim A",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "590309 Dim B",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "590309 Dim C",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "590310 Dim B",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "590311 Dim B",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "590312 Dim A",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "590313 Dim A",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "590313 Dim B",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "AC Handle per Unit",
  //    "Attribute translation": "AC Handle per Unit",
  //    "Apply to products(attribute)": "GLASSvent_CurtainWall_LeftCasement*|GLASSvent_CurtainWall_RightCasement*|GLASSvent_CurtainWall_ProjectOut*|GLASSvent_UT_RightCasement*|GLASSvent_UT_LeftCasement*|GLASSvent_UT_ProjectOut*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "AC/CL Handle per Unit",
  //    "Attribute translation": "AC/CL Handle per Unit",
  //    "Apply to products(attribute)": "GLASSvent_Storefront_ProjectOut*|GLASSvent_Storefront_RightCasement*|GLASSvent_Storefront_LeftCasement*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "Act Lf Hinge Info",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "ActivePnlFab",
  //    "Attribute translation": "Active Panel Fabrication Option",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "ActivePnlFab",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "AA3200M*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "ActivePnlFab",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "KD",
  //    "Attribute value translation": "Factory Fabricated, Shipped Knock Down",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "ActivePnlFab",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "SA",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "ActLeafDOW",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "STD_DR*DO|STD_DR*CRIP*|HW_DR*|TL_DR*|IR_*|TSD_DR*|190-*|350-*|400-*|450-*|451-*|500-*|540-*|550-*|551-*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "ActLeafDOW",
  //    "Attribute translation": "Active Leaf DOW",
  //    "Apply to products(attribute)": "STD_DR_Auto*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "ActLfDOW",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "AnchorHinge",
  //    "Attribute translation": "Anchor Hinge",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "Armored Strike",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "ASBiFold",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "AssmMethod",
  //    "Attribute translation": "Assembly Method",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "AutoShowRoom",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "Btm Dr Rail",
  //    "Attribute translation": "Bottom Rail",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "BtmDrClr",
  //    "Attribute translation": "Bottom Door Clearance",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "BtmDrClr",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "TL_*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "BtmRail",
  //    "Attribute translation": "Bottom Rail",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "BtmRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "BR01",
  //    "Attribute value translation": "200030 190 Standard Web Bottom Rail",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "BtmRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "BR02",
  //    "Attribute value translation": "200031 190 Deep Web Bottom Rail",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "BtmRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "BR03",
  //    "Attribute value translation": "200032 350/500 Standard Web Bottom Rail",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "BtmRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "BR04",
  //    "Attribute value translation": "200033 350/500 Deep Web Bottom Rail",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "BtmRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "BR04",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_DR*"
  //  },
  //  {
  //    "V6 option code": "BtmRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "BR05",
  //    "Attribute value translation": "200034 7 1/2\" Standard Web Bottom Rail",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "BtmRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "BR06",
  //    "Attribute value translation": "200035 7 1/2\" Deep Web Bottom Rail",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "BtmRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "BR06",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_DR*"
  //  },
  //  {
  //    "V6 option code": "BtmRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "BR12",
  //    "Attribute value translation": "200030/070/071 7 1/2\" Bottom Rail Converter",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "BtmRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "BR12",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_DR*"
  //  },
  //  {
  //    "V6 option code": "BtmRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "BR12DW",
  //    "Attribute value translation": "200031/070/071 7 1/2\" Bottom Rail Converter",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "BtmRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "BR12DW",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_DR*"
  //  },
  //  {
  //    "V6 option code": "BtmRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "BR13",
  //    "Attribute value translation": "200030/070/072 10\" Bottom Rail Converter",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "BtmRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "BR13",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_DR*"
  //  },
  //  {
  //    "V6 option code": "BtmRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "BR13DW",
  //    "Attribute value translation": "200031/070/072 10\" Bottom Rail Converter",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "BtmRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "BR13DW",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_DR*"
  //  },
  //  {
  //    "V6 option code": "BtmRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "BR14",
  //    "Attribute value translation": "200030/070/073 12\" Bottom Rail Converter",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "BtmRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "BR14",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_DR*"
  //  },
  //  {
  //    "V6 option code": "BtmRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "BR14DW",
  //    "Attribute value translation": "200031/070/073 12\" Bottom Rail Converter",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "BtmRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "BR14DW",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_DR*"
  //  },
  //  {
  //    "V6 option code": "BtmRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "BR15",
  //    "Attribute value translation": "200030/070/071/073 15 5/8\" Bottom Rail Converter",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "BtmRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "BR15",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_DR*"
  //  },
  //  {
  //    "V6 option code": "BtmRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "BR15DW",
  //    "Attribute value translation": "200031/070/071/073 15 5/8\" Bottom Rail Converter",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "BtmRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "BR15DW",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_DR*"
  //  },
  //  {
  //    "V6 option code": "BtmRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "BR16",
  //    "Attribute value translation": "200032/070/071 10 1/8\" Bottom Rail Converter 350/500",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "BtmRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "BR16",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_DR*"
  //  },
  //  {
  //    "V6 option code": "BtmRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "BR16DW",
  //    "Attribute value translation": "200033/070/071 10 1/8\" Bottom Rail Converter 350/500",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "BtmRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "BR16DW",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_DR*"
  //  },
  //  {
  //    "V6 option code": "BtmRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "BR17",
  //    "Attribute value translation": "200032/070/072 12 5/8\" Bottom Rail Converter 350/500",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "BtmRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "BR17",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_DR*"
  //  },
  //  {
  //    "V6 option code": "BtmRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "BR17DW",
  //    "Attribute value translation": "200033/070/072 12 5/8\" Bottom Rail Converter 350/500",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "BtmRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "BR17DW",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_DR*"
  //  },
  //  {
  //    "V6 option code": "BtmRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "BR18",
  //    "Attribute value translation": "200032/070/073 14 5/8\" Bottom Rail Converter 350/500",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "BtmRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "BR18",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_DR*"
  //  },
  //  {
  //    "V6 option code": "BtmRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "BR18DW",
  //    "Attribute value translation": "200033/070/073 14 5/8\" Bottom Rail Converter 350/500",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "BtmRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "BR18DW",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_DR*"
  //  },
  //  {
  //    "V6 option code": "BtmRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "BR20",
  //    "Attribute value translation": "200038 10\" Standard Web Bottom Rail",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "BtmRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "BR21",
  //    "Attribute value translation": "200039 10\" Deep Web Bottom Rail",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "BtmRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "BR21",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_DR*"
  //  },
  //  {
  //    "V6 option code": "BtmRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "BR22",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "BtmRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "BR23",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "BtmRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "BR24",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "BtmRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "BR26",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "BtmRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "BR26",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_DR*"
  //  },
  //  {
  //    "V6 option code": "BtmRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "BR27",
  //    "Attribute value translation": "200019 12\" Deep Web Bottom Rail",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "BtmRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "BR27",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_DR*"
  //  },
  //  {
  //    "V6 option code": "BtmRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "BR28",
  //    "Attribute value translation": "200188 10\" Standard Web Bottom Rail",
  //    "Apply to products(value)": "IR_HW*"
  //  },
  //  {
  //    "V6 option code": "BtmRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "BR29",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_HW*"
  //  },
  //  {
  //    "V6 option code": "BtmRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "BR30",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_HW*"
  //  },
  //  {
  //    "V6 option code": "BtmRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "BR31",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_HW*"
  //  },
  //  {
  //    "V6 option code": "BtmRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "BR32",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_HW*"
  //  },
  //  {
  //    "V6 option code": "BtmRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "KSTD",
  //    "Attribute value translation": "Std selection by Product and application",
  //    "Apply to products(value)": "IR_*"
  //  },
  //  {
  //    "V6 option code": "BtmRailHgt",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "Casters",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "CD_Paneline",
  //    "Attribute translation": "Cylinder Dogged Paneline",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "CD_Panic",
  //    "Attribute translation": "Cylinder Dogged Panic",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "Closer",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "3",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_DR*"
  //  },
  //  {
  //    "V6 option code": "Closer",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "4",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_DR*"
  //  },
  //  {
  //    "V6 option code": "Closer",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "6",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_DR*"
  //  },
  //  {
  //    "V6 option code": "Closer",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "6",
  //    "Attribute value translation": "International, Single Acting Only",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Closer",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "7",
  //    "Attribute value translation": "Norton 8101",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Closer",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "07PA",
  //    "Attribute value translation": "Norton 8101 PA",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Closer",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "07V",
  //    "Attribute value translation": "Norton 8101 w/ Cover",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Closer",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "07VPA",
  //    "Attribute value translation": "Norton 8101 PA w/ Cover",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Closer",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9",
  //    "Attribute value translation": "LCN 4040",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Closer",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "11",
  //    "Attribute value translation": "Falcon SC60",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Closer",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "15",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_DR*"
  //  },
  //  {
  //    "V6 option code": "Closer",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "16",
  //    "Attribute value translation": "Norton 1601",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Closer",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "16PA",
  //    "Attribute value translation": "Norton 1601 PA",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Closer",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "17",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "STD_DR*|HW_DR*|TL_DR*|IR_*|TSD_DR*|190-*|350-*|400-*|450-*|451-*|500-*|540-*|550-*|551-*"
  //  },
  //  {
  //    "V6 option code": "Closer",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "17PA",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "STD_DR*|HW_DR*|TL_DR*|IR_*|TSD_DR*|190-*|350-*|400-*|450-*|451-*|500-*|540-*|550-*|551-*"
  //  },
  //  {
  //    "V6 option code": "Closer",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "18",
  //    "Attribute value translation": "LCN 1260",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Closer",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "18V",
  //    "Attribute value translation": "LCN 1260 w/ Cover",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Closer",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "20",
  //    "Attribute value translation": "Calibre 690",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Closer",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "99",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Closer",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9901",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Closer",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9902",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Closer",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9903",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Closer",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9904",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "CloserHO",
  //    "Attribute translation": "Closer Hold Open (Refer to Catalog for Available Options)",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "CloserHO",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "100",
  //    "Attribute value translation": "100 Degree Hold Open",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "CloserHO",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "105",
  //    "Attribute value translation": "105 Degree Hold Open",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "CloserHO",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "85",
  //    "Attribute value translation": "85 Degree Hold Open",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "CloserHO",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "90",
  //    "Attribute value translation": "90 Degree Hold Open",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "CloserHO",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "999",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "CloserPrep",
  //    "Attribute translation": "Closer Supply Options",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "CloserPrep",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "2",
  //    "Attribute value translation": "Prep & Provide (no prep for surface closer)",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "CloserPrep",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "3",
  //    "Attribute value translation": "Prep & Provide Concealed closer arm (no closer)",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "COCSelecter",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "Conc_Pnc_ActLf_Only",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "CornerReinf",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "CustomLockLoc",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "CustomLockLoc_2",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "CustomLockLoc2",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "CustomPPullLoc",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "CustomPullLoc",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "CylGuard",
  //    "Attribute translation": "Cylinder Guard",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "CylGuard",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "1",
  //    "Attribute value translation": "Kawneer Standard Cylinder Guard Exterior",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "CylGuard",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "2",
  //    "Attribute value translation": "Kawneer Standard Cylinder Guard Interior",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "CylGuard",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "3",
  //    "Attribute value translation": "Kawneer Standard Cylinder Guard Exterior/Interior",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "CylGuard",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "4",
  //    "Attribute value translation": "Kawneer Standard (Paneline)",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "CylGuard",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9901_A",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "CylGuard",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9901_P",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Cylinder",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "1",
  //    "Attribute value translation": "Ext. Cylinder / Int. Thumbturn",
  //    "Apply to products(value)": "AA3200M*"
  //  },
  //  {
  //    "V6 option code": "CylKeyedAlike",
  //    "Attribute translation": "Cylinder Keyed Alike",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "DeadStop",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "DFTType",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "DLO Height Dimension",
  //    "Attribute translation": "Frame Opening DLO Height Dimension",
  //    "Apply to products(attribute)": "GLASSvent_UT_RightCasement*|GLASSvent_UT_LeftCasement*|GLASSvent_UT_ProjectOut*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "DLO Width Dimension",
  //    "Attribute translation": "Frame Opening DLO Width Dimension",
  //    "Apply to products(attribute)": "GLASSvent_UT_RightCasement*|GLASSvent_UT_LeftCasement*|GLASSvent_UT_ProjectOut*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "DLOHeightDimension",
  //    "Attribute translation": "Frame Opening DLO Height Dimension",
  //    "Apply to products(attribute)": "GLASSvent_Storefront_ProjectOut*|GLASSvent_Storefront_RightCasement*|GLASSvent_Storefront_LeftCasement*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "DLOWidthDimension",
  //    "Attribute translation": "Frame Opening DLO Width Dimension",
  //    "Apply to products(attribute)": "GLASSvent_Storefront_ProjectOut*|GLASSvent_Storefront_RightCasement*|GLASSvent_Storefront_LeftCasement*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "DoorAstragal",
  //    "Attribute translation": "Door Astragal",
  //    "Apply to products(attribute)": "2000T_DR_UNIT*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "DoorClearance",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "DoorFrameOnly",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "DoorHdr1",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "DoorHdr2",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "DoorHdr3",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "DoorHdr4",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "DoorHdr5",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "Dr_Type",
  //    "Attribute translation": "Door Type",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "DrGlass",
  //    "Attribute translation": "Door Glass/Infill",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "DrGlass",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "GS00",
  //    "Attribute value translation": "Omit Glass Stops",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "DrGlass",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "GS01",
  //    "Attribute value translation": "200041 1/4\" Beveled Glass Stop",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "DrGlass",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "GS02",
  //    "Attribute value translation": "200042 1/4\" Square Glass Stop",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "DrGlass",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "GS03",
  //    "Attribute value translation": "200042/043 3/8\" Square Glass Stop",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "DrGlass",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "GS03",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "STD_DR_Auto_Show_Room-both"
  //  },
  //  {
  //    "V6 option code": "DrGlass",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "GS04",
  //    "Attribute value translation": "200043 1/2\" Square Glass Stop",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "DrGlass",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "GS04",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "STD_DR_Auto_Show_Room-both"
  //  },
  //  {
  //    "V6 option code": "DrGlass",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "GS05",
  //    "Attribute value translation": "200043/044 5/8\" Square Glass Stop",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "DrGlass",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "GS05",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "STD_DR_Auto_Show_Room-both"
  //  },
  //  {
  //    "V6 option code": "DrGlass",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "GS06",
  //    "Attribute value translation": "200044 3/4\" Square Glass Stop",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "DrGlass",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "GS06",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "STD_DR_Auto_Show_Room-both"
  //  },
  //  {
  //    "V6 option code": "DrGlass",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "GS07",
  //    "Attribute value translation": "200045 1\" Square Glass Stop",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "DrGlass",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "GS07",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "STD_DR_Auto_Show_Room-both"
  //  },
  //  {
  //    "V6 option code": "DrGlass",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "GS999",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "DrGlass",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "IRGS03",
  //    "Attribute value translation": "9/16\" Structural Silicone Glazed",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "DrGlass",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "IRGS04",
  //    "Attribute value translation": "9/16\" Tape Glazed",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "DrGlass",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "IRGS05",
  //    "Attribute value translation": "9/16\" Dry Glazed",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "DrGlass",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "IRGS101",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "STD_DR_Auto_Show_Room-both"
  //  },
  //  {
  //    "V6 option code": "DrGlass",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "IRGS103",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "STD_DR_Auto_Show_Room-both"
  //  },
  //  {
  //    "V6 option code": "DrGlass",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "IRGS104",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "STD_DR_Auto_Show_Room-both"
  //  },
  //  {
  //    "V6 option code": "DrGlass",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "IRGS105",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "STD_DR_Auto_Show_Room-both"
  //  },
  //  {
  //    "V6 option code": "DrGlass",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "IRGS106",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "STD_DR_Auto_Show_Room-both"
  //  },
  //  {
  //    "V6 option code": "DrGlass",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "IRGS108",
  //    "Attribute value translation": "1\" Square Wet Glaze",
  //    "Apply to products(value)": "IR_*"
  //  },
  //  {
  //    "V6 option code": "DrGlass",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "IRGS109",
  //    "Attribute value translation": "9/16\" Square Tape Glaze",
  //    "Apply to products(value)": "IR_*"
  //  },
  //  {
  //    "V6 option code": "DrGlass",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "IRGS110",
  //    "Attribute value translation": "9/16\" Square Wet Glaze",
  //    "Apply to products(value)": "IR_*"
  //  },
  //  {
  //    "V6 option code": "DrGlass",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "IRGS111",
  //    "Attribute value translation": "1\" Square Tape Glaze",
  //    "Apply to products(value)": "IR_*"
  //  },
  //  {
  //    "V6 option code": "DrGlass",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "IRGS112",
  //    "Attribute value translation": "1\" Tape Glazed",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "DrGlass",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "IRGS113",
  //    "Attribute value translation": "1\" Dry Glazed",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "DrGlass",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "TSD_GS001",
  //    "Attribute value translation": "1\" Square Glass Stops",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "DrGlass_Security",
  //    "Attribute translation": "Glass Stop Security Adaptors",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "DrHolder",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "DropPlates",
  //    "Attribute translation": "Drop Plates",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "DropPlates",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "5",
  //    "Attribute value translation": "Norton 1600(037882)",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "DropPlates",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "6",
  //    "Attribute value translation": "Norton 1600PA(037883)",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "DropPlates",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "7",
  //    "Attribute value translation": "Norton 8100(037674)",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "DropPlates",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "8",
  //    "Attribute value translation": "Norton 8100PA(037675)",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "DrPositionSwitch",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "DrSweep",
  //    "Attribute translation": "Door Sweep",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "DrSweep",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "1",
  //    "Attribute value translation": "Kawneer Standard",
  //    "Apply to products(value)": "IR_DR*"
  //  },
  //  {
  //    "V6 option code": "DrSweep",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "02C",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "DrSweep",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "99",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "DrType",
  //    "Attribute translation": "Door Type",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "DrType",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "1",
  //    "Attribute value translation": "190 Narrow Stile",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "DrType",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "2",
  //    "Attribute value translation": "350 Medium Stile",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "DrType",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "2",
  //    "Attribute value translation": "350 IR - Medium Stile",
  //    "Apply to products(value)": "IR_DR*"
  //  },
  //  {
  //    "V6 option code": "DrType",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "3",
  //    "Attribute value translation": "500 Wide Stile",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "DrType",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "3",
  //    "Attribute value translation": "500 IR - Wide Stile",
  //    "Apply to products(value)": "IR_DR*"
  //  },
  //  {
  //    "V6 option code": "DrType",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "6",
  //    "Attribute value translation": "350 Tuffline - Medium Stile",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "DrType",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "7",
  //    "Attribute value translation": "500 Tuffline - Wide Stile",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "DrType",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9",
  //    "Attribute value translation": "350 Heavy Wall - Medium Stile",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "DrType",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9",
  //    "Attribute value translation": "350 IR Heavy Wall - Medium Stile",
  //    "Apply to products(value)": "IR_DR*"
  //  },
  //  {
  //    "V6 option code": "DrType",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "10",
  //    "Attribute value translation": "500 Heavy Wall - Wide Stile",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "DrType",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "10",
  //    "Attribute value translation": "500 IR Heavy Wall - Wide Stile",
  //    "Apply to products(value)": "IR_DR*"
  //  },
  //  {
  //    "V6 option code": "DrType",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "14",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "DrType",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "15",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "Egress",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "GLASSvent_Storefront_RightCasement*|GLASSvent_Storefront_LeftCasement*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "EL_EPT",
  //    "Attribute translation": "Electric Power Transfer",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "EL_KeyPad",
  //    "Attribute translation": "Electronic KeyPad",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "EL_KeyPad",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "IR_DR*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "EL_Paneline",
  //    "Attribute translation": "Electric Paneline",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "EL_Panic",
  //    "Attribute translation": "Electric Panic",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "EL_PowerSupply",
  //    "Attribute translation": "Electric Power Supply",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "EL_PowerSupply",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "40",
  //    "Attribute value translation": "(16/1790 ONLY) 1 per Unit (SP1000)",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "ElectHinge",
  //    "Attribute translation": "Electric Hinge",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "Electric Strike",
  //    "Attribute translation": "Electric Strike",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "Electric Strike",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9901_A",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Electric Strike",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9901_P",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Electric Strike",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9902_A",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Electric Strike",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9902_P",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "ElectTransfer",
  //    "Attribute translation": "Electric Power Transfer",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "ElectTransfer",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "EH1",
  //    "Attribute value translation": "1 Kawneer Standard Electric Hinge",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "ElectTransfer",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "EHBL",
  //    "Attribute value translation": "1 Kawneer Std Electric Hinge on Each Leaf",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "ElectTransfer",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "EHLS",
  //    "Attribute value translation": "1 Kawneer Std Electric Hinge on InActive Leaf",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "ElectTransfer",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "EHRS",
  //    "Attribute value translation": "1 Kawneer Std Electric Hinge on Active Leaf",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "ElectTransfer",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "EP1",
  //    "Attribute value translation": "050396 Securitron EPT",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "ElectTransfer",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "EP1BL",
  //    "Attribute value translation": "050396 Securitron EPT on Each Leaf",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "ElectTransfer",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "EP1LS",
  //    "Attribute value translation": "050396 Securitron EPT on InActive Leaf",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "ElectTransfer",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "EP1RS",
  //    "Attribute value translation": "050396 Securitron EPT on Active Leaf",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "ElectTransfer",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "EP2",
  //    "Attribute value translation": "050405 Von Duprin EPT-2",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "ElectTransfer",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "EP2BL",
  //    "Attribute value translation": "050405 Von Duprin EPT-2 on Each Leaf",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "ElectTransfer",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "EP2LS",
  //    "Attribute value translation": "050405 Von Duprin EPT-2 on InActive Leaf",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "ElectTransfer",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "EP2RS",
  //    "Attribute value translation": "050405 Von Duprin EPT-2 on Active Leaf",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "ElectTransfer",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "EP3",
  //    "Attribute value translation": "050406 Von Duprin EPT-10",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "ElectTransfer",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "EP3BL",
  //    "Attribute value translation": "050406 Von Duprin EPT-10 on Each Leaf",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "ElectTransfer",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "EP3LS",
  //    "Attribute value translation": "050406 Von Duprin EPT-10 on InActive Leaf",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "ElectTransfer",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "EP3RS",
  //    "Attribute value translation": "050406 Von Duprin EPT-10 on Active Leaf",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "ElectTransfer",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "VD9901_P",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "ElectTransfer",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "VD9902_P",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "ElectTransfer",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "VD9903_P",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "ElectTransfer",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "VD9904_P",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "EmarkUnitNum",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "EqlDLOW",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "Exit_Device_Options",
  //    "Attribute translation": "Exit Device Options",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "Exit_Device_Options",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "IR_*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "ExitIndicator",
  //    "Attribute translation": "Exit Indicator",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "ExitIndicator",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "IR_*|HW_*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "ExitIndicator",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "1",
  //    "Attribute value translation": "037131 Kawneer Standard Interior",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "ExitIndicator",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "01B",
  //    "Attribute value translation": "037131 Kawneer Standard Interior/Exterior",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "ExitIndicator",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "01E",
  //    "Attribute value translation": "037131 Kawneer Standard Exterior",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "ExteriorDoorLogoFinish",
  //    "Attribute translation": "Exterior Door Logo Finish",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "ExtLckOp",
  //    "Attribute translation": "Exterior Lock Operator",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "ExtLckOp",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "1",
  //    "Attribute value translation": "Kawneer Standard Cylinder",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "ExtLckOp",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "1",
  //    "Attribute value translation": "Cylinder",
  //    "Apply to products(value)": "990*|1010*"
  //  },
  //  {
  //    "V6 option code": "ExtLckOp",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "2",
  //    "Attribute value translation": "Kawneer Standard Keyed Alike Cylinder",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "ExtLckOp",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "2",
  //    "Attribute value translation": "T-Turn (MS or Extruded Pull Only)",
  //    "Apply to products(value)": "990*|1010*"
  //  },
  //  {
  //    "V6 option code": "ExtLckOp",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "3",
  //    "Attribute value translation": "Kawneer Standard Thumbturn",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "ExtLckOp",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "4",
  //    "Attribute value translation": "Kawneer Standard Dummy Cylinder",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "ExtLckOp",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "4",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_DR*"
  //  },
  //  {
  //    "V6 option code": "ExtLckOp",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "5",
  //    "Attribute value translation": "Prep Only for Kawneer Standard",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "ExtLckOp",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "5",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_DR*"
  //  },
  //  {
  //    "V6 option code": "ExtLckOp",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "6",
  //    "Attribute value translation": "Falcon 1490/1590 Night Latch, Key Different",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "ExtLckOp",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "7",
  //    "Attribute value translation": "Falcon 1490/1590 Hold Open, Key Different",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "ExtLckOp",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "8",
  //    "Attribute value translation": "Falcon 1490/1590 Night Latch, Key Alike",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "ExtLckOp",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9",
  //    "Attribute value translation": "Falcon 1490/1590 Hold Open, Key Alike",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "ExtLckOp",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9901_A",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "ExtLckOp",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9901_P",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "ExtLckOp Info",
  //    "Attribute translation": "Exterior Lock Operator Information",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "ExtLckOp_2",
  //    "Attribute translation": "Exterior Lock Operator #2",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "ExtLckOp_2",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "1",
  //    "Attribute value translation": "Kawneer Standard Cylinder",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "ExtLckOp_2",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "2",
  //    "Attribute value translation": "Kawneer Standard Keyed Alike Cylinder",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "ExtLckOp_2",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "3",
  //    "Attribute value translation": "Kawneer Standard Thumbturn",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "ExtLckOp_2",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "4",
  //    "Attribute value translation": "Kawneer Standard Dummy Cylinder",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "ExtLckOp_2",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "5",
  //    "Attribute value translation": "Prep Only for Kawneer Standard",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "ExtLckOp_2",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9901_A",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "ExtLckOp_2",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9901_P",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "ExtLockOp",
  //    "Attribute translation": "Exterior Lock Operator",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "FabFirst",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "FabricationMethod",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "AA3200M*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "Face 1.HeightDim",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "GLASSvent_UT_RightCasement*|GLASSvent_UT_LeftCasement*|GLASSvent_UT_ProjectOut*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "Face 1.Widthdim",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "GLASSvent_UT_RightCasement*|GLASSvent_UT_LeftCasement*|GLASSvent_UT_ProjectOut*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "FGuard",
  //    "Attribute translation": "Finger Guard",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "FieldGlazing",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "FixedPnlGlz",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "AA3200M*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "FlushboltOp",
  //    "Attribute translation": "Flushbolt Operator",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "Flushbolts",
  //    "Attribute translation": "Flushbolts",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "Flushbolts",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "1",
  //    "Attribute value translation": "Kawneer Standard",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Flushbolts",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9901_A",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Flushbolts",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9901_P",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Flushbolts",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9902_A",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Flushbolts",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9902_P",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Flushbolts",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9903_A",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Flushbolts",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9903_P",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Flushbolts",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9904_A",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Flushbolts",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9904_P",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Frame Size Limits",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "GLASSvent_UT_RightCasement*|GLASSvent_UT_LeftCasement*|GLASSvent_UT_ProjectOut*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "FrameFab",
  //    "Attribute translation": "Frame Fabrication Option",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "FrameFab",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "AA3200M*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "FrameFab",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "KD",
  //    "Attribute value translation": "Factory Fabricated, Shipped Knock Down",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "FrameFab",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "SA",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "FrameGlazing",
  //    "Attribute translation": "Frame Glazing",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "FrameGlazing",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "0",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "FrameGlazing",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "01C",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "FrameGlazing",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "99",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "FrameGlazing",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "ALERT",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "FrameSystem",
  //    "Attribute translation": "Frame System",
  //    "Apply to products(attribute)": "GLASSvent_UT_ProjectOut*|GLASSvent_UT_RightCasement*|GLASSvent_UT_LeftCasement*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "FrameSystem",
  //    "Attribute translation": "Adaptor Type",
  //    "Apply to products(attribute)": "GLASSvent_Storefront_ProjectOut*|GLASSvent_Storefront_RightCasement*|GLASSvent_Storefront_LeftCasement*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "FrameSystem",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "1",
  //    "Attribute value translation": "Trifab 400/Trifab VG 450 Adapters (450087)",
  //    "Apply to products(value)": "GLASSvent_Storefront_ProjectOut*|GLASSvent_Storefront_RightCasement*|GLASSvent_Storefront_LeftCasement*"
  //  },
  //  {
  //    "V6 option code": "FrameSystem",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "2",
  //    "Attribute value translation": "Trifab VG 451/451T Adapters (469407)",
  //    "Apply to products(value)": "GLASSvent_Storefront_ProjectOut*|GLASSvent_Storefront_RightCasement*|GLASSvent_Storefront_LeftCasement*"
  //  },
  //  {
  //    "V6 option code": "FrameSystem",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "3",
  //    "Attribute value translation": "EnCore Adapters (452132)",
  //    "Apply to products(value)": "GLASSvent_Storefront_ProjectOut*|GLASSvent_Storefront_RightCasement*|GLASSvent_Storefront_LeftCasement*"
  //  },
  //  {
  //    "V6 option code": "FrameSystem",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "4",
  //    "Attribute value translation": "IR501T/IR501UT (575204)",
  //    "Apply to products(value)": "GLASSvent_Storefront_ProjectOut*|GLASSvent_Storefront_RightCasement*|GLASSvent_Storefront_LeftCasement*"
  //  },
  //  {
  //    "V6 option code": "FrameType",
  //    "Attribute translation": "Frame Type",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "FrameType",
  //    "Attribute translation": "Frame Type",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "FrameType",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "1",
  //    "Attribute value translation": "Trifab 400",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "FrameType",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "1",
  //    "Attribute value translation": "Trifab 400",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "FrameType",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "05P",
  //    "Attribute value translation": "Encore 4 1/2\" - 1 Piece Jambs",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "FrameType",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "05P",
  //    "Attribute value translation": "Encore 4 1/2\" - 1 Piece Jambs",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "FrameType",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "05PP",
  //    "Attribute value translation": "Encore 4 1/2\" - 2 Piece Jambs",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "FrameType",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "05PP",
  //    "Attribute value translation": "Encore 4 1/2\" - 2 Piece Jambs",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "FrameType",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "06PP",
  //    "Attribute value translation": "Encore 6\" - 2 Piece Jambs",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "FrameType",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "06PP",
  //    "Attribute value translation": "Encore 6\" - 2 Piece Jambs",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "FrameType",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "101A",
  //    "Attribute value translation": "162047 Flush Wall Adaptor",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "FrameType",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "11",
  //    "Attribute value translation": "Trifab VG 450",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "FrameType",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "12",
  //    "Attribute value translation": "Trifab VG 451",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "FrameType",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "13",
  //    "Attribute value translation": "Trifab VG 451T",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "FrameType",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "15",
  //    "Attribute value translation": "Trifab 451T Thermal",
  //    "Apply to products(value)": "TSD_*"
  //  },
  //  {
  //    "V6 option code": "FrameType",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "15",
  //    "Attribute value translation": "Standard Thermal w/ 451T Sidelites",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "FrameType",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "16",
  //    "Attribute value translation": "Trifab 601",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "FrameType",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "16F",
  //    "Attribute value translation": "Trifab 601 (Tubular w/ Fin)",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "FrameType",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "17",
  //    "Attribute value translation": "Trifab 601T Thermal",
  //    "Apply to products(value)": "TSD_*"
  //  },
  //  {
  //    "V6 option code": "FrameType",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "17",
  //    "Attribute value translation": "Trifab 601T",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "FrameType",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "18",
  //    "Attribute value translation": "Trifab 601UT Ultra Thermal",
  //    "Apply to products(value)": "TSD_*"
  //  },
  //  {
  //    "V6 option code": "FrameType",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "18",
  //    "Attribute value translation": "Trifab 601T w/ 601UT Sidelites",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "FrameType",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "20DG",
  //    "Attribute value translation": "Tuffline Standard Weight Double Glaze",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "FrameType",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "20SG",
  //    "Attribute value translation": "Tuffline Standard Weight Single Glaze",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "FrameType",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "21DG",
  //    "Attribute value translation": "Tuffline Heavy Weight Double Glaze",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "FrameType",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "21SG",
  //    "Attribute value translation": "Tuffline Heavy Weight Single Glaze",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "FrameType",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "22DG",
  //    "Attribute value translation": "Tuffline Half Jamb Double Glaze",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "FrameType",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "22SG",
  //    "Attribute value translation": "Tuffline Half Jamb Single Glaze",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "FrameType",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "IR1600",
  //    "Attribute value translation": "163036 7/8\" Wall Adaptor (450 Header)",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "FrameType",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "IR450",
  //    "Attribute value translation": "Trifab 450 CG",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "FrameType",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "IR451",
  //    "Attribute value translation": "Trifab 451 CG",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "FrameType",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "IR451T",
  //    "Attribute value translation": "Trifab 451T CG",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "FrameType",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "IR501",
  //    "Attribute value translation": "IR 501",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "FrameType",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "IR501T",
  //    "Attribute value translation": "IR 501T",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "FrameType",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "IR501UT",
  //    "Attribute value translation": "IR 501UT",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "FrameType",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "WA01",
  //    "Attribute value translation": "162043 ¾ Wall Adaptor (TriFab Header)",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "FrameType",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "WA02",
  //    "Attribute value translation": "162044 ¾ Wall Adaptor (TriFab Header)",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "FrameType",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "WA03",
  //    "Attribute value translation": "163036 7/8 Wall Adaptor (TriFab Header)",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "FrameType",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "WA04",
  //    "Attribute value translation": "162089 ¾ Wall Adaptor (TriFab Header)",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "FrameType",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "WA05",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "FrameType",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "WA09",
  //    "Attribute value translation": "824220 29/32\" Thermal Wall Adaptor",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Frm Width",
  //    "Attribute translation": "Frame Width",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "Frm_Height",
  //    "Attribute translation": "Frame Height",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "Frm_Width",
  //    "Attribute translation": "Frame Width",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "FrmType",
  //    "Attribute translation": "Frame Type",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "FrmType",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "11",
  //    "Attribute value translation": "Trifab VG 450",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "FrmType",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "12",
  //    "Attribute value translation": "Trifab VG 451",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "FrmType",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "13",
  //    "Attribute value translation": "Trifab VG 451T",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "FrmType",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "15",
  //    "Attribute value translation": "Standard Thermal w/ 451T Sidelites",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "FrmType",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "16",
  //    "Attribute value translation": "Trifab 601",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "FrmType",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "16F",
  //    "Attribute value translation": "Trifab 601 (Tubular w/ Fin)",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "FrmType",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "17",
  //    "Attribute value translation": "Trifab 601T",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "FrmType",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "18",
  //    "Attribute value translation": "Trifab 601T w/ 601UT Sidelites",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "GlassDesc",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "GLASSvent_CurtainWall_LeftCasement*|GLASSvent_CurtainWall_RightCasement*|GLASSvent_CurtainWall_ProjectOut*|GLASSvent_Storefront_ProjectOut*|GLASSvent_Storefront_RightCasement*|GLASSvent_Storefront_LeftCasement*|GLASSvent_UT_ProjectOut*|GLASSvent_UT_RightCasement*|GLASSvent_UT_LeftCasement*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "GlassStopType",
  //    "Attribute translation": "Glass Stop Type",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "GlassType",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "GLASSvent_CurtainWall_LeftCasement*|GLASSvent_CurtainWall_RightCasement*|GLASSvent_CurtainWall_ProjectOut*|GLASSvent_Storefront_ProjectOut*|GLASSvent_Storefront_RightCasement*|GLASSvent_Storefront_LeftCasement*|GLASSvent_UT_ProjectOut*|GLASSvent_UT_RightCasement*|GLASSvent_UT_LeftCasement*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "GlassVentType",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "GLASSvent_Storefront_ProjectOut*|GLASSvent_Storefront_RightCasement*|GLASSvent_Storefront_LeftCasement*|GLASSvent_UT_ProjectOut*|GLASSvent_UT_RightCasement*|GLASSvent_UT_LeftCasement*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "GlazeFrom",
  //    "Attribute translation": "Glaze From",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "GlazeFrom",
  //    "Attribute translation": "Glaze From",
  //    "Apply to products(attribute)": "TSD_DR*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "Glazing",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "GlazingMethod",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "AA3200M*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "GlazingPosition",
  //    "Attribute translation": "Glazing Position",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "Hand",
  //    "Attribute translation": "Handing",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "Hand",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "1",
  //    "Attribute value translation": "S/A LHOS (H/R OUT-SWING)",
  //    "Apply to products(value)": "IR_*"
  //  },
  //  {
  //    "V6 option code": "Hand",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "2",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "STD_DR*|HW_DR*|TL_DR*|IR_*|TSD_DR*|190-*|350-*|400-*|450-*|451-*|500-*|540-*|550-*|551-*"
  //  },
  //  {
  //    "V6 option code": "Hand",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "3",
  //    "Attribute value translation": "S/A RHOS (H/L OUT-SWING)",
  //    "Apply to products(value)": "IR_*"
  //  },
  //  {
  //    "V6 option code": "Hand",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "4",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "STD_DR*|HW_DR*|TL_DR*|IR_*|TSD_DR*|190-*|350-*|400-*|450-*|451-*|500-*|540-*|550-*|551-*"
  //  },
  //  {
  //    "V6 option code": "Hand",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "7",
  //    "Attribute value translation": "S/A PAIR (LHOS Active)",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Hand",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "8",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "STD_DR*|HW_DR*|TL_DR*|IR_*|TSD_DR*|190-*|350-*|400-*|450-*|451-*|500-*|540-*|550-*|551-*"
  //  },
  //  {
  //    "V6 option code": "Hand",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9",
  //    "Attribute value translation": "D/A PAIR (LHOS?HR/Active)",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Hand",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "10",
  //    "Attribute value translation": "S/A PAIR (RHOS Active)",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Hand",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "11",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "STD_DR*|HW_DR*|TL_DR*|IR_*|TSD_DR*|190-*|350-*|400-*|450-*|451-*|500-*|540-*|550-*|551-*"
  //  },
  //  {
  //    "V6 option code": "Handle",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "97",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "AA3200M*"
  //  },
  //  {
  //    "V6 option code": "Handle",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "99",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "AA3200M*"
  //  },
  //  {
  //    "V6 option code": "Hardware",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "Head Options",
  //    "Attribute translation": "Frame Head Options",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "HeadRcpt",
  //    "Attribute translation": "Head Receptor",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "HeadRcpt",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "1",
  //    "Attribute value translation": "Typical 5\" Head (259221)",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "HeadRcpt",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "2",
  //    "Attribute value translation": "FG501T Head Receptor (259220)",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "HeadRcpt",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "3",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Height",
  //    "Attribute translation": "Actual Vent Height (Tip to Tip)",
  //    "Apply to products(attribute)": "GLASSvent_Storefront_ProjectOut*|GLASSvent_Storefront_RightCasement*|GLASSvent_Storefront_LeftCasement*|GLASSvent_UT_ProjectOut*|GLASSvent_UT_RightCasement*|GLASSvent_UT_LeftCasement*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "Height",
  //    "Attribute translation": "Frame Height",
  //    "Apply to products(attribute)": "AA3200M*|1010*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "HeightDimension",
  //    "Attribute translation": "Height",
  //    "Apply to products(attribute)": "GLASSvent_Storefront_ProjectOut*|GLASSvent_Storefront_RightCasement*|GLASSvent_Storefront_LeftCasement*|GLASSvent_UT_ProjectOut*|GLASSvent_UT_RightCasement*|GLASSvent_UT_LeftCasement*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "Hinge",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "0",
  //    "Attribute value translation": "None (Beveled Stile)",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Hinge",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "0",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_*"
  //  },
  //  {
  //    "V6 option code": "Hinge",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "00A",
  //    "Attribute value translation": "None (Stiles for Offset Pivots)",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Hinge",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "00B",
  //    "Attribute value translation": "None (Stiles for Butt Hinges)",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Hinge",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "00C",
  //    "Attribute value translation": "None (Rabbeted Hinge Stiles)",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Hinge",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "00R",
  //    "Attribute value translation": "None (Radius Stile)",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Hinge",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "1",
  //    "Attribute value translation": "Standard Offset Pivots",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Hinge",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "2",
  //    "Attribute value translation": "Standard Butt Hinges",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Hinge",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "04C",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_*"
  //  },
  //  {
  //    "V6 option code": "Hinge",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "04C",
  //    "Attribute value translation": "US32D SS Butts",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Hinge",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "5",
  //    "Attribute value translation": "Standard Continuous Hinge",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Hinge",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "6",
  //    "Attribute value translation": "Top Walking Beam Pivot / No prep at Bottom",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Hinge",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "8",
  //    "Attribute value translation": "C/H Bottom Pivot / Top Walking Beam Pivot",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Hinge",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Hinge",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "10",
  //    "Attribute value translation": "Standard Top Offset Pivot (No Bottom)",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Hinge",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "10",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_*|TSD_DR*"
  //  },
  //  {
  //    "V6 option code": "Hinge",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "11",
  //    "Attribute value translation": "Standard Bottom Offset Pivot (M19 Top-#17/#40 Only)",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Hinge",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "11",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_*|TSD_DR*"
  //  },
  //  {
  //    "V6 option code": "Hinge",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "12",
  //    "Attribute value translation": "Standard Top/Bottom Offset Pivot (M19 Int-#17/#40 Only)",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Hinge",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "12",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_DR_*"
  //  },
  //  {
  //    "V6 option code": "Hinge",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "15",
  //    "Attribute value translation": "Standard Top Offset Pivot (M19 Int-#17/#40 Only/No Bottom)",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Hinge",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "15",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_*|TSD_DR*"
  //  },
  //  {
  //    "V6 option code": "Hinge",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "15C",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Hinge",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "16",
  //    "Attribute value translation": "Standard 304 SS NRP Butts (#17/#29 Only)",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Hinge",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "86",
  //    "Attribute value translation": "None (Rabbeted Hinge Stiles)",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Hinge",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "86",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_*"
  //  },
  //  {
  //    "V6 option code": "Hinge",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9901_A",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Hinge",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9901_P",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Hinge",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9902_A",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Hinge",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9902_P",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Hinge",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9903_A",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Hinge",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9903_P",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Hinge",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9904_A",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Hinge",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9904_P",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Hinge",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9905_A",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Hinge",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9905_P",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Hinge",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9907_A",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Hinge",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9907_P",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Hinge",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9908_A",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Hinge",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9908_P",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Hinge",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9909_A",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Hinge",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9909_P",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Hinge",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9910_A",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Hinge",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9910_P",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Hinge",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9911_A",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Hinge",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9911_P",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Hinge",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9912_A",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Hinge",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9912_P",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Hinge",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9913_A",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Hinge",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9913_P",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Hinge",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9914_A",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Hinge",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9914_P",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Hinge",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9915_A",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Hinge",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9915_P",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Hinge",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9916_A",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Hinge",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9916_P",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Hinge",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9917_A",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Hinge",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9917_P",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Hinge",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9918_A",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Hinge",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9918_P",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Hinge",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9919_A",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Hinge",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9919_P",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Hinge",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9920_A",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Hinge",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9920_P",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Hinge",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9921_A",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Hinge",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9921_P",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Hinge Finish",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "29",
  //    "Attribute value translation": "29 (Not available for Rixon M19)",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Hinge Finish",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "OPPNT",
  //    "Attribute value translation": "Painted Offset Pivots - Standard Pivots Only",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "HingeClr",
  //    "Attribute translation": "Hinge Clearance",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "HingeClr",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "IR_*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "HingeClr",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "TL_*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "HWVD44XRTEST",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "ID",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "Impact",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "GLASSvent_UT*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "InAct Lf Hinge Info",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "InAct MtStl Hinge Info",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "Infill",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "1",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "990*|1010*"
  //  },
  //  {
  //    "V6 option code": "Infill",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "1",
  //    "Attribute value translation": "1/4\"",
  //    "Apply to products(value)": "GLASSvent_Storefront_ProjectOut*|GLASSvent_CurtainWall_LeftCasement*|GLASSvent_CurtainWall_RightCasement*|GLASSvent_CurtainWall_ProjectOut*"
  //  },
  //  {
  //    "V6 option code": "Infill",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "2",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "990*|1010*"
  //  },
  //  {
  //    "V6 option code": "Infill",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "4",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "990*|1010*"
  //  },
  //  {
  //    "V6 option code": "Infill",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "6",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "990*|1010*"
  //  },
  //  {
  //    "V6 option code": "InteriorDoorLogoFinish",
  //    "Attribute translation": "Interior Door Logo Finish",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "InteriorDoorSweepFinish",
  //    "Attribute translation": "Interior Door Sweep Finish",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "InteriorDoorSweepFinish",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "22",
  //    "Attribute value translation": "Painted to Match Door",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "IntIRLckOp",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "IntLckOp",
  //    "Attribute translation": "Interior Lock Operator",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "IntLckOp",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "1",
  //    "Attribute value translation": "Kawneer Standard Cylinder",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "IntLckOp",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "1",
  //    "Attribute value translation": "Cylinder (1850 Only)",
  //    "Apply to products(value)": "990*|1010*"
  //  },
  //  {
  //    "V6 option code": "IntLckOp",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "2",
  //    "Attribute value translation": "Kawneer Standard Keyed Alike Cylinder",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "IntLckOp",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "2",
  //    "Attribute value translation": "T-Turn (MS or Extruded Pull Only)",
  //    "Apply to products(value)": "990*|1010*"
  //  },
  //  {
  //    "V6 option code": "IntLckOp",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "3",
  //    "Attribute value translation": "Kawneer Standard Thumbturn",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "IntLckOp",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "3",
  //    "Attribute value translation": "Slide (Latch Lock Only)",
  //    "Apply to products(value)": "990*|1010*"
  //  },
  //  {
  //    "V6 option code": "IntLckOp",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "4",
  //    "Attribute value translation": "Kawneer Standard Dummy Cylinder",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "IntLckOp",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "4",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_*"
  //  },
  //  {
  //    "V6 option code": "IntLckOp",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "5",
  //    "Attribute value translation": "Prep Only for Kawneer Standard",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "IntLckOp",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "5",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_*"
  //  },
  //  {
  //    "V6 option code": "IntLckOp",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9901_A",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "IntLckOp",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9901_P",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "IntLckOp Info",
  //    "Attribute translation": "Interior Lock Operator Information",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "IntLockOp",
  //    "Attribute translation": "Interior Lock Operator",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "IRA2_HNG",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "IRA2_LCK",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "IRA2_PRC",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "IRHW_PRC",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "IRLock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "IRSteelReinf",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "IRTwoPieceHeader",
  //    "Attribute translation": "Transom Glass Stop @ Top",
  //    "Apply to products(attribute)": "IR_DR*|IR_HW_DR*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "KeyedRemMullion",
  //    "Attribute translation": "Keyed Removable Mullion",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "LckType",
  //    "Attribute translation": "LckType",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "Left SL Dim",
  //    "Attribute translation": "Left Sidelight Dimension",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "Left SL Dim Input",
  //    "Attribute translation": "Left Sidelight Dimension Input",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "LeftDrClr",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "LeftDrJamb",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "Limit Opening In inches to",
  //    "Attribute translation": "Limit Stop Opening (In Inches)",
  //    "Apply to products(attribute)": "GLASSvent_UT_RightCasement*|GLASSvent_UT_LeftCasement*|GLASSvent_UT_ProjectOut*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "Limit Stop Opening",
  //    "Attribute translation": "Limit Stop Opening (In Inches)",
  //    "Apply to products(attribute)": "GLASSvent_Storefront_ProjectOut*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "LimitStop",
  //    "Attribute translation": "Limit Stop",
  //    "Apply to products(attribute)": "GLASSvent_CurtainWall_LeftCasement*|GLASSvent_CurtainWall_RightCasement*|GLASSvent_CurtainWall_ProjectOut*|GLASSvent_Storefront_ProjectOut*|GLASSvent_Storefront_RightCasement*|GLASSvent_Storefront_LeftCasement*|GLASSvent_UT_ProjectOut*|GLASSvent_UT_RightCasement*|GLASSvent_UT_LeftCasement*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "LimitStop",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "0",
  //    "Attribute value translation": "Standard Opening",
  //    "Apply to products(value)": "GLASSvent_Storefront_RightCasement*|GLASSvent_Storefront_LeftCasement*"
  //  },
  //  {
  //    "V6 option code": "LimitStop",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "0",
  //    "Attribute value translation": "No Limit Stop",
  //    "Apply to products(value)": "GLASSvent_Storefront_ProjectOut*"
  //  },
  //  {
  //    "V6 option code": "LimitStop",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "1",
  //    "Attribute value translation": "Limit Per Opening Specified",
  //    "Apply to products(value)": "GLASSvent_Storefront_ProjectOut*"
  //  },
  //  {
  //    "V6 option code": "LimitStop",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "3",
  //    "Attribute value translation": "Limit Per Opening Specified",
  //    "Apply to products(value)": "GLASSvent_Storefront_RightCasement*|GLASSvent_Storefront_LeftCasement*"
  //  },
  //  {
  //    "V6 option code": "LimitStop",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "KSTD",
  //    "Attribute value translation": "229108 Limit Stop",
  //    "Apply to products(value)": "GLASSvent_UT_ProjectOut*"
  //  },
  //  {
  //    "V6 option code": "LimitStop",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "KSTD",
  //    "Attribute value translation": "229122 or 229123 Limit Stop (Based on Size)",
  //    "Apply to products(value)": "GLASSvent_UT_RightCasement*|GLASSvent_UT_LeftCasement*"
  //  },
  //  {
  //    "V6 option code": "LimitStop",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "KSTD",
  //    "Attribute value translation": "Kawneer Standard of 10\" Limit",
  //    "Apply to products(value)": "GLASSvent_CurtainWall_ProjectOut*"
  //  },
  //  {
  //    "V6 option code": "LimitStop",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "KSTD",
  //    "Attribute value translation": "Kawneer Standard 8\"",
  //    "Apply to products(value)": "GLASSvent_Storefront_ProjectOut*"
  //  },
  //  {
  //    "V6 option code": "LimitStop",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "NONE",
  //    "Attribute value translation": "Standard Opening",
  //    "Apply to products(value)": "GLASSvent_UT_RightCasement*|GLASSvent_UT_LeftCasement*|GLASSvent_UT_ProjectOut*"
  //  },
  //  {
  //    "V6 option code": "LJambRcpt",
  //    "Attribute translation": "Left Jamb Receptor",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "LL_Operator",
  //    "Attribute translation": "Latch Lock Operator",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "LL_Operator",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "0",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "LL_Operator",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "4",
  //    "Attribute value translation": "4560 Lever Handle Interior & Exterior",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "0",
  //    "Attribute value translation": "(Select Locking)",
  //    "Apply to products(value)": "990*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "0",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "1",
  //    "Attribute value translation": "MS 1850 Deadbolt",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "1",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "1",
  //    "Attribute value translation": "MS 1850 Hookbolt",
  //    "Apply to products(value)": "990*|1010*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "01A",
  //    "Attribute value translation": "MS 1950 Stainless Steel Hookbolt",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "01M",
  //    "Attribute value translation": "2 MS Locks (MS 1850 Default)",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "01M",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "2",
  //    "Attribute value translation": "MS 1850 Deadbolt w/ 2 Point Lock",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "2",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "2",
  //    "Attribute value translation": "1848 Latch Lock",
  //    "Apply to products(value)": "990*|1010*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "3",
  //    "Attribute value translation": "MS 1850 Deadbolt w/ 3 Point Lock",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "3",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "3",
  //    "Attribute value translation": "1847 Stainless Steel Latch",
  //    "Apply to products(value)": "990*|1010*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "03IR",
  //    "Attribute value translation": "MS 1850 Deadbolt 3 Point IR Lock (IR Flushbolts Inactive)",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "03S",
  //    "Attribute value translation": "MS 1850 Deadbolt w/ 3 Point Lock (Shuttered)",
  //    "Apply to products(value)": "TSD_DR*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "03S",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "4",
  //    "Attribute value translation": "MS 1853 Short Throw Deadbolt",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "4",
  //    "Attribute value translation": "Bottom Rail Lock",
  //    "Apply to products(value)": "990*|1010*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "4",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "5",
  //    "Attribute value translation": "MS 1850 Hookbolt",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "5",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "05IR",
  //    "Attribute value translation": "MS 1850 5 Point IR Lock (AR 2180 Inactive)",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "6",
  //    "Attribute value translation": "4510 Latch Lock",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "6",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "06B",
  //    "Attribute value translation": "4510 Latch Lock w/ MS 1850 Below",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "06B",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_*|TSD_DR*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "06T",
  //    "Attribute value translation": "4510 Latch Lock w/ MS 1850 Above",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "06T",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_*|TSD_DR*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9",
  //    "Attribute value translation": "MS + 1890 Latch Lock",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "12",
  //    "Attribute value translation": "Paneline",
  //    "Apply to products(value)": "IR_*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "12A",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "14",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "15",
  //    "Attribute value translation": "Falcon 1990 CVR Panic",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "15",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "16",
  //    "Attribute value translation": "Falcon 2090 Rim Panic",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "16",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "16",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "20",
  //    "Attribute value translation": "Falcon 1690 CVR Panic",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "20",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "20IR",
  //    "Attribute value translation": "Falcon HH1690 CVR Panic",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "21",
  //    "Attribute value translation": "Falcon 1790 Rim Panic",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "21",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "23",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "24",
  //    "Attribute value translation": "Dummy Paneline",
  //    "Apply to products(value)": "IR_*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "28",
  //    "Attribute value translation": "Falcon 1790 Rim Panic W/O Rem Mullion",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "29",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "30",
  //    "Attribute value translation": "Jackson 2086 CVR Panic",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "31",
  //    "Attribute value translation": "Adams Rite 8400 Rim Panic",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "31",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "32",
  //    "Attribute value translation": "Adams Rite 8400 Rim Panic w/ El Strike (Intermittent - Standard)",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "32",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "33",
  //    "Attribute value translation": "Adams Rite 8600 CVR Panic",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "33",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "34",
  //    "Attribute value translation": "Standard 1686 CVR Panic",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "35",
  //    "Attribute value translation": "Sargent 8400AD CVR Panic",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "36",
  //    "Attribute value translation": "Calibre 9100 CVR Panic",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "37",
  //    "Attribute value translation": "Adams Rite G86 CVR Panic",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "38",
  //    "Attribute value translation": "Von Duprin 9947 CVR Panic (425 Only)",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "38",
  //    "Attribute value translation": "Von Duprin HH9947 CVR Panic",
  //    "Apply to products(value)": "IR_HW_*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "38",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_DR_*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "38IR",
  //    "Attribute value translation": "Von Duprin 9947HH CVR Panic",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "39",
  //    "Attribute value translation": "Standard 1786 Rim Panic",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "39",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "40",
  //    "Attribute value translation": "Standard 1786 Rim Panic W/O Rem Mullion",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "41",
  //    "Attribute value translation": "Adams Rite 8400 Rim Panic w/ El Strike (Continuous)",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "41",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "42",
  //    "Attribute value translation": "Von Duprin 3347 CVR Panic",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "44",
  //    "Attribute value translation": "Von Duprin 98/99 XP Rim Panic w/ Mullion on Pairs",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "45",
  //    "Attribute value translation": "Corbin Russwin ED5200S Rim Panic w/ Mullion on Pairs",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "99",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9901_A",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9901_P",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9902_A",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9902_P",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9903_A",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9903_P",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9904_A",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9904_P",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9905_A",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9905_P",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9906_A",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9906_P",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9907_A",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9907_P",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9908_A",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9908_P",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9909_A",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9909_P",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9910_A",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9910_P",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9911_A",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9911_P",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9912_A",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9912_P",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9913_A",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9913_P",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9914_A",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9914_P",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9915_A",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9915_P",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9916_A",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9916_P",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9917_A",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9917_P",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9918_A",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Lock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9918_P",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "LockClr",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "Locking",
  //    "Attribute translation": "Lock",
  //    "Apply to products(attribute)": "GLASSvent_CurtainWall_LeftCasement*|GLASSvent_CurtainWall_RightCasement*|GLASSvent_CurtainWall_ProjectOut*|GLASSvent_Storefront_ProjectOut*|GLASSvent_Storefront_RightCasement*|GLASSvent_Storefront_LeftCasement*|GLASSvent_UT_ProjectOut*|GLASSvent_UT_RightCasement*|GLASSvent_UT_LeftCasement*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "Locking",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "1",
  //    "Attribute value translation": "Cam Handle",
  //    "Apply to products(value)": "GLASSvent_CurtainWall_LeftCasement*|GLASSvent_CurtainWall_RightCasement*|GLASSvent_CurtainWall_ProjectOut*|GLASSvent_Storefront_ProjectOut*|GLASSvent_Storefront_RightCasement*|GLASSvent_Storefront_LeftCasement*|GLASSvent_UT_ProjectOut*|GLASSvent_UT_RightCasement*|GLASSvent_UT_LeftCasement*"
  //  },
  //  {
  //    "V6 option code": "Locking",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "2",
  //    "Attribute value translation": "Cam Handle with Pole Ring",
  //    "Apply to products(value)": "GLASSvent_CurtainWall_LeftCasement*|GLASSvent_CurtainWall_RightCasement*|GLASSvent_CurtainWall_ProjectOut*|GLASSvent_Storefront_ProjectOut*|GLASSvent_Storefront_RightCasement*|GLASSvent_Storefront_LeftCasement*|GLASSvent_UT_ProjectOut*|GLASSvent_UT_RightCasement*|GLASSvent_UT_LeftCasement*"
  //  },
  //  {
  //    "V6 option code": "Locking",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "3",
  //    "Attribute value translation": "Access Control (Custodial) Lock",
  //    "Apply to products(value)": "GLASSvent_CurtainWall_LeftCasement*|GLASSvent_CurtainWall_RightCasement*|GLASSvent_CurtainWall_ProjectOut*|GLASSvent_Storefront_ProjectOut*|GLASSvent_Storefront_RightCasement*|GLASSvent_Storefront_LeftCasement*|GLASSvent_UT_ProjectOut*|GLASSvent_UT_RightCasement*|GLASSvent_UT_LeftCasement*"
  //  },
  //  {
  //    "V6 option code": "Locking",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "4",
  //    "Attribute value translation": "Concealed Lock",
  //    "Apply to products(value)": "GLASSvent_CurtainWall_LeftCasement*|GLASSvent_CurtainWall_RightCasement*|GLASSvent_CurtainWall_ProjectOut*|GLASSvent_Storefront_ProjectOut*|GLASSvent_Storefront_RightCasement*|GLASSvent_Storefront_LeftCasement*"
  //  },
  //  {
  //    "V6 option code": "Locking",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "5",
  //    "Attribute value translation": "Multi-Point Lock",
  //    "Apply to products(value)": "GLASSvent_Storefront_RightCasement*|GLASSvent_Storefront_LeftCasement*"
  //  },
  //  {
  //    "V6 option code": "Locking",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "6",
  //    "Attribute value translation": "Pivot-Shoe Roto-Operator",
  //    "Apply to products(value)": "GLASSvent_Storefront_ProjectOut*"
  //  },
  //  {
  //    "V6 option code": "Locking",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "7",
  //    "Attribute value translation": "Hook Bolt Lock",
  //    "Apply to products(value)": "GLASSvent_CurtainWall_LeftCasement*|GLASSvent_CurtainWall_RightCasement*|GLASSvent_Storefront_RightCasement*|GLASSvent_Storefront_LeftCasement*"
  //  },
  //  {
  //    "V6 option code": "Locking",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "7",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "GLASSvent_CurtainWall_ProjectOut*"
  //  },
  //  {
  //    "V6 option code": "Locking",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "8",
  //    "Attribute value translation": "Multi-Point Lock",
  //    "Apply to products(value)": "GLASSvent_CurtainWall_LeftCasement*|GLASSvent_CurtainWall_RightCasement*"
  //  },
  //  {
  //    "V6 option code": "Locking",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9",
  //    "Attribute value translation": "Omni-Drive",
  //    "Apply to products(value)": "GLASSvent_UT_ProjectOut*"
  //  },
  //  {
  //    "V6 option code": "Locking",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "99",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "GLASSvent_CurtainWall_LeftCasement*|GLASSvent_CurtainWall_RightCasement*|GLASSvent_CurtainWall_ProjectOut*|GLASSvent_Storefront_ProjectOut*|GLASSvent_Storefront_RightCasement*|GLASSvent_Storefront_LeftCasement*"
  //  },
  //  {
  //    "V6 option code": "Locking",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "99",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "AA3200M*"
  //  },
  //  {
  //    "V6 option code": "LockPatLoc",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "GLASSvent_CurtainWall_LeftCasement*|GLASSvent_CurtainWall_RightCasement*|GLASSvent_CurtainWall_ProjectOut*|GLASSvent_Storefront_ProjectOut*|GLASSvent_Storefront_RightCasement*|GLASSvent_Storefront_LeftCasement*|GLASSvent_UT_ProjectOut*|GLASSvent_UT_RightCasement*|GLASSvent_UT_LeftCasement*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "LockStrikeOn",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "LooseRivetHinge",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "GLASSvent_CurtainWall_ProjectOut*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "LPThreshold",
  //    "Attribute translation": "Low Profile Threshold",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "LSL Shim Space",
  //    "Attribute translation": "Left Sidelight Shim Space",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "MagLock",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "MiscHBO",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "MiscHBO_DrLabor",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "MiscHBO_FrLabor",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "NF",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "PanicTrim",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "IR_DR*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "PanicTrim",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9901",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "PanicTrim",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9902",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "PanicTrim",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9903",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "PanicTrim",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9904",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "PanicTrim",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9905",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "PanicTrim",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9906",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "PanicTrim",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9907",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "PanicTrim",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9908",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "PanicTrim_Single",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "PerimeterFastenerPrep",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "PlinePPadFin",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "PncPull",
  //    "Attribute translation": "Pull",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "PncPull",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "13",
  //    "Attribute value translation": "CO-9 Pull",
  //    "Apply to products(value)": "IR_*"
  //  },
  //  {
  //    "V6 option code": "PncPull",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "14",
  //    "Attribute value translation": "CO-12 Pull",
  //    "Apply to products(value)": "IR_*"
  //  },
  //  {
  //    "V6 option code": "PncPull",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "15",
  //    "Attribute value translation": "CPN Pull",
  //    "Apply to products(value)": "IR_*"
  //  },
  //  {
  //    "V6 option code": "PncPull",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9901_A",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "PncPull",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9901_P",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "PncPull",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9903_A",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "PncPull",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9903_P",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "PncPull",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9904_A",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "PncPull",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9904_P",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "PncPull",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9905_A",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "PncPull",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9905_P",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "PocketAdapters",
  //    "Attribute translation": "Adaptor Type",
  //    "Apply to products(attribute)": "GLASSvent_CurtainWall_LeftCasement*|GLASSvent_CurtainWall_RightCasement*|GLASSvent_CurtainWall_ProjectOut*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "PocketFillers",
  //    "Attribute translation": "Pocket Fillers",
  //    "Apply to products(attribute)": "GLASSvent_UT_RightCasement*|GLASSvent_UT_LeftCasement*|GLASSvent_UT_ProjectOut*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "Pole Ring Limits",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "GLASSvent_UT_ProjectOut*|GLASSvent_UT_RightCasement*|GLASSvent_UT_LeftCasement*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "PoleRing",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "GLASSvent_UT_ProjectOut*|GLASSvent_UT_RightCasement*|GLASSvent_UT_LeftCasement*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "PPull Info",
  //    "Attribute translation": "Push/Pull Info",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "PPullSet",
  //    "Attribute translation": "Push/Pull Set",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "PPullSet",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "113",
  //    "Attribute value translation": "CP Pushes Back to Back",
  //    "Apply to products(value)": "IR_*"
  //  },
  //  {
  //    "V6 option code": "PPullSet",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "116",
  //    "Attribute value translation": "CO-9 Pull with CP Push",
  //    "Apply to products(value)": "IR_*"
  //  },
  //  {
  //    "V6 option code": "PPullSet",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "117",
  //    "Attribute value translation": "CO-12 Pull with CP Push",
  //    "Apply to products(value)": "IR_*"
  //  },
  //  {
  //    "V6 option code": "PPullSet",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "118",
  //    "Attribute value translation": "CO-9 Pulls Back to Back",
  //    "Apply to products(value)": "IR_*"
  //  },
  //  {
  //    "V6 option code": "PPullSet",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "119",
  //    "Attribute value translation": "CO-12 Pulls Back to Back",
  //    "Apply to products(value)": "IR_*"
  //  },
  //  {
  //    "V6 option code": "PPullSet",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "13",
  //    "Attribute value translation": "CO-9 Pull",
  //    "Apply to products(value)": "IR_*"
  //  },
  //  {
  //    "V6 option code": "PPullSet",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "14",
  //    "Attribute value translation": "CO-12 Pull",
  //    "Apply to products(value)": "IR_*"
  //  },
  //  {
  //    "V6 option code": "PPullSet",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "213",
  //    "Attribute value translation": "CPII Pushes Back to Back",
  //    "Apply to products(value)": "IR_*"
  //  },
  //  {
  //    "V6 option code": "PPullSet",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "216",
  //    "Attribute value translation": "CO-9 Pull with CPII Push",
  //    "Apply to products(value)": "IR_*"
  //  },
  //  {
  //    "V6 option code": "PPullSet",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "217",
  //    "Attribute value translation": "CO-12 Pull with CPII Push",
  //    "Apply to products(value)": "IR_*"
  //  },
  //  {
  //    "V6 option code": "PPullSet",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9901_A",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "PPullSet",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9901_P",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "PPullSet",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9902_A",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "PPullSet",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9902_P",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "PPullSet",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9903_A",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "PPullSet",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9903_P",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "PPullSet",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9904_A",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "PPullSet",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9904_P",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "PPullSet",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9905_A",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "PPullSet",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9905_P",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Product",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "AA3200M*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "PSFSpec",
  //    "Attribute translation": "PSF Specification",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "Pulls",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "1",
  //    "Attribute value translation": "Flush Both Sides",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Pulls",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "2",
  //    "Attribute value translation": "Flush Interior",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Pulls",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "3",
  //    "Attribute value translation": "Flush Exterior",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Pulls",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "4",
  //    "Attribute value translation": "Extruded Both Sides",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Pulls",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "5",
  //    "Attribute value translation": "Extruded Interior",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Pulls",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "6",
  //    "Attribute value translation": "Extruded Exterior",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Pulls",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "99",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Qty of Int Inact LF",
  //    "Attribute translation": "Quantity of Intermediates Inactive Leaf",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "Qty of Intermediates",
  //    "Attribute translation": "Quantity of Intermediates/Leaf",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "Qty of NRP",
  //    "Attribute translation": "Quantity of NRP/Total",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "Qty of NRP Inact LF",
  //    "Attribute translation": "Quantity of NRP Inactive Leaf",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "RelocIntPivot",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "ReqForExit",
  //    "Attribute translation": "Request For Exit",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "Right SL Dim",
  //    "Attribute translation": "Right Sidelight Dimension",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "RightDrClr",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "RightDrJamb",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "RJambRcpt",
  //    "Attribute translation": "Right Jamb Receptor",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "Roller Gear Manufacturer",
  //    "Attribute translation": "Roller Gear Lock Option",
  //    "Apply to products(attribute)": "2000T_DR_UNIT*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "Roller Gear Manufacturer",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "1",
  //    "Attribute value translation": "Hoppe HLS7 Series (standard)",
  //    "Apply to products(value)": "2000T_DR_UNIT*"
  //  },
  //  {
  //    "V6 option code": "RotoOperator",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "GLASSvent_UT_ProjectOut*|GLASSvent_UT_RightCasement*|GLASSvent_UT_LeftCasement*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "RotoOperator",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "NA",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "GLASSvent_UT_ProjectOut*|GLASSvent_UT_RightCasement*|GLASSvent_UT_LeftCasement*"
  //  },
  //  {
  //    "V6 option code": "RSL Shim Space",
  //    "Attribute translation": "Right Sidelight Shim Space",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "SA",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "SA2",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "SA3",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "SA4",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "SA5",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "ScreenMesh",
  //    "Attribute translation": "Screen Mesh",
  //    "Apply to products(attribute)": "GLASSvent_CurtainWall_LeftCasement*|GLASSvent_CurtainWall_RightCasement*|GLASSvent_CurtainWall_ProjectOut*|GLASSvent_Storefront_ProjectOut*|GLASSvent_Storefront_RightCasement*|GLASSvent_Storefront_LeftCasement*|GLASSvent_UT_ProjectOut*|GLASSvent_UT_RightCasement*|GLASSvent_UT_LeftCasement*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "ScreenMesh",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "3",
  //    "Attribute value translation": "Aluminum -  Charcoal Grey",
  //    "Apply to products(value)": "GLASSvent_CurtainWall_LeftCasement*|GLASSvent_CurtainWall_RightCasement*|GLASSvent_CurtainWall_ProjectOut*|GLASSvent_Storefront_ProjectOut*|GLASSvent_Storefront_RightCasement*|GLASSvent_Storefront_LeftCasement*|GLASSvent_UT_ProjectOut*|GLASSvent_UT_RightCasement*|GLASSvent_UT_LeftCasement*"
  //  },
  //  {
  //    "V6 option code": "ScreenMesh",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "4",
  //    "Attribute value translation": "Aluminum -  Natural Brite-Kote",
  //    "Apply to products(value)": "GLASSvent_CurtainWall_LeftCasement*|GLASSvent_CurtainWall_RightCasement*|GLASSvent_CurtainWall_ProjectOut*|GLASSvent_Storefront_ProjectOut*|GLASSvent_Storefront_RightCasement*|GLASSvent_Storefront_LeftCasement*|GLASSvent_UT_ProjectOut*|GLASSvent_UT_RightCasement*|GLASSvent_UT_LeftCasement*"
  //  },
  //  {
  //    "V6 option code": "ScreenMesh",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "5",
  //    "Attribute value translation": "Aluminum -  Black",
  //    "Apply to products(value)": "GLASSvent_CurtainWall_LeftCasement*|GLASSvent_CurtainWall_RightCasement*|GLASSvent_CurtainWall_ProjectOut*|GLASSvent_Storefront_ProjectOut*|GLASSvent_Storefront_RightCasement*|GLASSvent_Storefront_LeftCasement*|GLASSvent_UT_ProjectOut*|GLASSvent_UT_RightCasement*|GLASSvent_UT_LeftCasement*"
  //  },
  //  {
  //    "V6 option code": "ScreenMesh",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "999",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "GLASSvent_CurtainWall_LeftCasement*|GLASSvent_CurtainWall_RightCasement*|GLASSvent_CurtainWall_ProjectOut*|GLASSvent_Storefront_ProjectOut*|GLASSvent_Storefront_RightCasement*|GLASSvent_Storefront_LeftCasement*|GLASSvent_UT_ProjectOut*|GLASSvent_UT_RightCasement*|GLASSvent_UT_LeftCasement*"
  //  },
  //  {
  //    "V6 option code": "Screens",
  //    "Attribute translation": "Screen",
  //    "Apply to products(attribute)": "GLASSvent_CurtainWall_LeftCasement*|GLASSvent_CurtainWall_RightCasement*|GLASSvent_CurtainWall_ProjectOut*|GLASSvent_Storefront_ProjectOut*|GLASSvent_Storefront_RightCasement*|GLASSvent_Storefront_LeftCasement*|GLASSvent_UT_ProjectOut*|GLASSvent_UT_RightCasement*|GLASSvent_UT_LeftCasement*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "Screens",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "0",
  //    "Attribute value translation": "None",
  //    "Apply to products(value)": "GLASSvent_CurtainWall_LeftCasement*|GLASSvent_CurtainWall_RightCasement*|GLASSvent_CurtainWall_ProjectOut*|GLASSvent_UT_ProjectOut*|GLASSvent_UT_RightCasement*|GLASSvent_UT_LeftCasement*"
  //  },
  //  {
  //    "V6 option code": "Screens",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "1",
  //    "Attribute value translation": "716505 - COS Screen w/ 9\" Full Height Wicket",
  //    "Apply to products(value)": "GLASSvent_Storefront_RightCasement*|GLASSvent_Storefront_LeftCasement*"
  //  },
  //  {
  //    "V6 option code": "Screens",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "2",
  //    "Attribute value translation": "716506 - COS Screen w/ Full Wicket",
  //    "Apply to products(value)": "GLASSvent_Storefront_RightCasement*|GLASSvent_Storefront_LeftCasement*"
  //  },
  //  {
  //    "V6 option code": "Screens",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "3",
  //    "Attribute value translation": "716511 - COS Flat Screen w/ Full Height Wicket",
  //    "Apply to products(value)": "GLASSvent_Storefront_RightCasement*|GLASSvent_Storefront_LeftCasement*"
  //  },
  //  {
  //    "V6 option code": "Screens",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "5",
  //    "Attribute value translation": "716505 - COS Screen w/ 9\" Full Height Wicket",
  //    "Apply to products(value)": "GLASSvent_CurtainWall_LeftCasement*|GLASSvent_CurtainWall_RightCasement*|GLASSvent_UT_RightCasement*|GLASSvent_UT_LeftCasement*"
  //  },
  //  {
  //    "V6 option code": "Screens",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "6",
  //    "Attribute value translation": "716506 - COS Screen w/ Full Wicket",
  //    "Apply to products(value)": "GLASSvent_CurtainWall_LeftCasement*|GLASSvent_CurtainWall_RightCasement*|GLASSvent_UT_RightCasement*|GLASSvent_UT_LeftCasement*"
  //  },
  //  {
  //    "V6 option code": "Screens",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "7",
  //    "Attribute value translation": "716507 - PO Screen for Pole Ring Full Height Wicket",
  //    "Apply to products(value)": "GLASSvent_UT_ProjectOut*"
  //  },
  //  {
  //    "V6 option code": "Screens",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "8",
  //    "Attribute value translation": "716508 - PO Screen for Pole Ring Full Wicket and Wickets at Ends",
  //    "Apply to products(value)": "GLASSvent_UT_ProjectOut*|GLASSvent_Storefront_ProjectOut*|GLASSvent_CurtainWall_ProjectOut*"
  //  },
  //  {
  //    "V6 option code": "Screens",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "9",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "GLASSvent_CurtainWall_LeftCasement*|GLASSvent_CurtainWall_RightCasement*"
  //  },
  //  {
  //    "V6 option code": "Screens",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "11",
  //    "Attribute value translation": "716511 - COS Flat Screen w/ Full Height Wicket",
  //    "Apply to products(value)": "GLASSvent_CurtainWall_LeftCasement*|GLASSvent_CurtainWall_RightCasement*"
  //  },
  //  {
  //    "V6 option code": "ScreenType",
  //    "Attribute translation": "Screen Type",
  //    "Apply to products(attribute)": "GLASSvent_Storefront_ProjectOut*|GLASSvent_Storefront_RightCasement*|GLASSvent_Storefront_LeftCasement*|GLASSvent_CurtainWall_LeftCasement*|GLASSvent_CurtainWall_RightCasement*|GLASSvent_CurtainWall_ProjectOut*|GLASSvent_UT_RightCasement*|GLASSvent_UT_LeftCasement*|GLASSvent_UT_ProjectOut*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "Segment",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "SetInFrame",
  //    "Attribute translation": "Frame System",
  //    "Apply to products(attribute)": "GLASSvent_UT_RightCasement*|GLASSvent_UT_LeftCasement*|GLASSvent_UT_ProjectOut*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "SetInFrame",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "0",
  //    "Attribute value translation": "(Select Frame System)",
  //    "Apply to products(value)": "GLASSvent_UT_RightCasement*|GLASSvent_UT_LeftCasement*|GLASSvent_UT_ProjectOut*"
  //  },
  //  {
  //    "V6 option code": "SiliconeGlazed",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "SiliconeSettingBlk",
  //    "Attribute translation": "Silicone Setting Block",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "SillFlashing",
  //    "Attribute translation": "Sill Flashing",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "SillFlashing",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "2",
  //    "Attribute value translation": "Kawneer Hi Performance",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "SillType",
  //    "Attribute translation": "Sill Type",
  //    "Apply to products(attribute)": "AA3200M*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "Size Limitation",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "AA3200M*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "Size Limitations",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "AA3200M*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "SL Base Info",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "SLBase",
  //    "Attribute translation": "Sidelight Base",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "SLBase",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "1",
  //    "Attribute value translation": "Standard Sidelight Base",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "SLBase",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "2",
  //    "Attribute value translation": "Std Adjustable Sidelite Base",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "SLBase",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "3",
  //    "Attribute value translation": "Tall Adjustable Sidelite Base",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "SLBase",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "4",
  //    "Attribute value translation": "4 1/2\" Sidelight Base",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "SLBase",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "5",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "SLBase",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "6",
  //    "Attribute value translation": "10\" (200039/450099) Sidelight Base",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "SLBase",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "99",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "SLBaseHgt",
  //    "Attribute translation": "Sidelight Base Height",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "Spec_AI_CLSR",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "Spec_AI_DRHLDR",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "Spec_AI_PP",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "Spec_COC_Dop",
  //    "Attribute translation": "Hinge Type for Concealed Closer Prep",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "Spec_COC_Dop",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "IR_*|TL_*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "Spec_COC_Dop",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "1",
  //    "Attribute value translation": "Required when hinge omitted with Kawneer concealed closer",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Spec_Leaf_C-Rod_Panic",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "Spec_Leaf_for_Closer",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "Spec_Leaf_for_PPull",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "SSGSideRails",
  //    "Attribute translation": "SSG Side Rails",
  //    "Apply to products(attribute)": "GLASSvent_CurtainWall_ProjectOut*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "Staked",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "Std Hinges",
  //    "Attribute translation": "Standard Hinges",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "StockLength",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "StrikeOptions",
  //    "Attribute translation": "Strike Options",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "StrikeOptions",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "IR_*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "StrikeOptions",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "AS9903_A",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "StrikeOptions",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "AS9903_P",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "StrikeOptions",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "ES01",
  //    "Attribute value translation": "Kawneer Standard Electric Strike(Int Duty 24VAC/12VDC)",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "StrikeOptions",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "ES02",
  //    "Attribute value translation": "Alternate Electric Strike(Cont Duty 24VDC)",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "StrikeOptions",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "ES9902_A",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "StrikeOptions",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "ES9902_P",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "SystemDepth",
  //    "Attribute translation": "Frame Depth",
  //    "Apply to products(attribute)": "GLASSvent_UT_RightCasement*|GLASSvent_UT_LeftCasement*|GLASSvent_UT_ProjectOut*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "SystemDepth",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "DEEP",
  //    "Attribute value translation": "Deep System",
  //    "Apply to products(value)": "GLASSvent_UT_RightCasement*|GLASSvent_UT_LeftCasement*|GLASSvent_UT_ProjectOut*"
  //  },
  //  {
  //    "V6 option code": "SystemDepth",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "SHALLOW",
  //    "Attribute value translation": "Shallow System",
  //    "Apply to products(value)": "GLASSvent_UT_RightCasement*|GLASSvent_UT_LeftCasement*|GLASSvent_UT_ProjectOut*"
  //  },
  //  {
  //    "V6 option code": "TBar",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "TBar1",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "TBar2",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "TBar3",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "TBar4",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "TBar5",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "Thold",
  //    "Attribute translation": "Threshold",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "Thold",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "99",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Thold",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "KSTD",
  //    "Attribute value translation": "Kawneer Standard Threshold",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Thold",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "KSTDPO",
  //    "Attribute value translation": "Prep Only Kawneer Standard Threshold",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Thold",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "SEL",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "STD_DR_1DO*|HW_DR_1DO*|IR_HW_DR_1DO*|TSD_DR_1DO*|IR_DR_1DO*"
  //  },
  //  {
  //    "V6 option code": "Thold",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "TH04",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Thold",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "TH06",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Thold",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "TH108C",
  //    "Attribute value translation": "450053 S/A Threshold (Canada)",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Thold",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "TH108CPO",
  //    "Attribute value translation": "Prep Only 450053 S/A Threshold (Canada)",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Thold",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "TH109C",
  //    "Attribute value translation": "450055 S/A Threshold (Canada)",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Thold",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "TH109CPO",
  //    "Attribute value translation": "Prep Only 450055 S/A Threshold (Canada)",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Thold",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "TH999",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "Thold_ ADA_ Access",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "ThresholdAdapter",
  //    "Attribute translation": "Threshold Adapter",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "Top Dr Rail",
  //    "Attribute translation": "Top Rail",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "TopDrClr",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "TopRail",
  //    "Attribute translation": "Top Rail",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "TopRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "KSTD",
  //    "Attribute value translation": "Std selection by Product and application",
  //    "Apply to products(value)": "IR_*"
  //  },
  //  {
  //    "V6 option code": "TopRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "TLTR04",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_HW*"
  //  },
  //  {
  //    "V6 option code": "TopRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "TR04",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_DR*"
  //  },
  //  {
  //    "V6 option code": "TopRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "TR05",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_DR*"
  //  },
  //  {
  //    "V6 option code": "TopRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "TR06",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_DR*"
  //  },
  //  {
  //    "V6 option code": "TopRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "TR07",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_DR*"
  //  },
  //  {
  //    "V6 option code": "TopRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "TR08",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_DR*"
  //  },
  //  {
  //    "V6 option code": "TopRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "TR09",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_DR*"
  //  },
  //  {
  //    "V6 option code": "TopRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "TR10",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_DR*"
  //  },
  //  {
  //    "V6 option code": "TopRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "TR11",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_DR*"
  //  },
  //  {
  //    "V6 option code": "TopRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "TR12",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_DR*"
  //  },
  //  {
  //    "V6 option code": "TopRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "TR13",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_DR*"
  //  },
  //  {
  //    "V6 option code": "TopRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "TR14",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_DR*"
  //  },
  //  {
  //    "V6 option code": "TopRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "TR15",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_DR*"
  //  },
  //  {
  //    "V6 option code": "TopRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "TR16",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_DR*"
  //  },
  //  {
  //    "V6 option code": "TopRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "TR17",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_HW*"
  //  },
  //  {
  //    "V6 option code": "TopRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "TR18",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_HW*"
  //  },
  //  {
  //    "V6 option code": "TopRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "TR19",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_DR*"
  //  },
  //  {
  //    "V6 option code": "TopRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "TR20",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_DR*"
  //  },
  //  {
  //    "V6 option code": "TopRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "TR22",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_DR*"
  //  },
  //  {
  //    "V6 option code": "TopRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "TR23",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_DR*"
  //  },
  //  {
  //    "V6 option code": "TopRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "TR24",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_HW*"
  //  },
  //  {
  //    "V6 option code": "TopRail",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "TR25",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "IR_HW*"
  //  },
  //  {
  //    "V6 option code": "Trans_Hdr",
  //    "Attribute translation": "Transom Header",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "TransHdr",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "TRFrm_Height",
  //    "Attribute translation": "Transom Frame Height",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "TrimSet",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "TrkQty",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "Tubular",
  //    "Attribute translation": "Tubular (non openback)",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "TufflineFrm",
  //    "Attribute translation": "Frame Type",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "TufflineFrm",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "22DG",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "TL_DR_CRIP*|TL_DR_2DO|TL_DR_3DO|TL_DR_4DO|TL_DR_5DO"
  //  },
  //  {
  //    "V6 option code": "TufflineFrm",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "22DT",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "TL_DR_CRIP*|TL_DR_2DO|TL_DR_3DO|TL_DR_4DO|TL_DR_5DO"
  //  },
  //  {
  //    "V6 option code": "TufflineFrm",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "22SG",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "TL_DR_CRIP*|TL_DR_2DO|TL_DR_3DO|TL_DR_4DO|TL_DR_5DO"
  //  },
  //  {
  //    "V6 option code": "UC",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "UnitID",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "AA3200M*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "Vent Dimension Type",
  //    "Attribute translation": "Vent Dimension Type",
  //    "Apply to products(attribute)": "GLASSvent_Storefront_ProjectOut*|GLASSvent_Storefront_RightCasement*|GLASSvent_Storefront_LeftCasement*|GLASSvent_UT_ProjectOut*|GLASSvent_UT_RightCasement*|GLASSvent_UT_LeftCasement*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "Vent Dimension Type",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "0",
  //    "Attribute value translation": "(Select Vent Dimension Type)",
  //    "Apply to products(value)": "GLASSvent_Storefront_ProjectOut*|GLASSvent_Storefront_RightCasement*|GLASSvent_Storefront_LeftCasement*|GLASSvent_UT_ProjectOut*|GLASSvent_UT_RightCasement*|GLASSvent_UT_LeftCasement*"
  //  },
  //  {
  //    "V6 option code": "Vent Dimension Type",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "AVS",
  //    "Attribute value translation": "Actual Vent Size (Tip to Tip)",
  //    "Apply to products(value)": "GLASSvent_Storefront_ProjectOut*|GLASSvent_Storefront_RightCasement*|GLASSvent_Storefront_LeftCasement*|GLASSvent_UT_ProjectOut*|GLASSvent_UT_RightCasement*|GLASSvent_UT_LeftCasement*"
  //  },
  //  {
  //    "V6 option code": "Vent Dimension Type",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "DLO",
  //    "Attribute value translation": "Frame Opening (DLOW & DLOH)",
  //    "Apply to products(value)": "GLASSvent_Storefront_ProjectOut*|GLASSvent_Storefront_RightCasement*|GLASSvent_Storefront_LeftCasement*|GLASSvent_UT_ProjectOut*|GLASSvent_UT_RightCasement*|GLASSvent_UT_LeftCasement*"
  //  },
  //  {
  //    "V6 option code": "VentWgt",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "GLASSvent_CurtainWall_LeftCasement*|GLASSvent_CurtainWall_RightCasement*|GLASSvent_CurtainWall_ProjectOut*|GLASSvent_Storefront_ProjectOut*|GLASSvent_Storefront_RightCasement*|GLASSvent_Storefront_LeftCasement*|GLASSvent_UT_ProjectOut*|GLASSvent_UT_RightCasement*|GLASSvent_UT_LeftCasement*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "WADrHdr-MatchJambs",
  //    "Attribute translation": "Wall Adapter Door Header (Match Jambs)",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "WADrHdr-MatchJambs",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "TSD_DR*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "WADrHdr-Mitered",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "Width",
  //    "Attribute translation": "Actual Vent Width (Tip to Tip)",
  //    "Apply to products(attribute)": "GLASSvent_Storefront_ProjectOut*|GLASSvent_Storefront_RightCasement*|GLASSvent_Storefront_LeftCasement*|GLASSvent_UT_ProjectOut*|GLASSvent_UT_RightCasement*|GLASSvent_UT_LeftCasement*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "Width",
  //    "Attribute translation": "Frame Width",
  //    "Apply to products(attribute)": "AA3200M*|1010*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "WidthDimension",
  //    "Attribute translation": "Width",
  //    "Apply to products(attribute)": "GLASSvent_Storefront_ProjectOut*|GLASSvent_Storefront_RightCasement*|GLASSvent_Storefront_LeftCasement*|GLASSvent_UT_ProjectOut*|GLASSvent_UT_RightCasement*|GLASSvent_UT_LeftCasement*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "WindowFamily",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "GLASSvent_CurtainWall_LeftCasement*|GLASSvent_CurtainWall_RightCasement*|GLASSvent_CurtainWall_ProjectOut*|GLASSvent_Storefront_ProjectOut*|GLASSvent_Storefront_RightCasement*|GLASSvent_Storefront_LeftCasement*|GLASSvent_UT_ProjectOut*|GLASSvent_UT_RightCasement*|GLASSvent_UT_LeftCasement*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "W-Shld/K-Plts",
  //    "Attribute translation": "Wear Shield/Kick Plates",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "W-Shld/K-Plts",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "99",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "XRails",
  //    "Attribute translation": "Cross Rails",
  //    "Apply to products(attribute)": "*",
  //    "Attribute value code": "",
  //    "Attribute value translation": "",
  //    "Apply to products(value)": ""
  //  },
  //  {
  //    "V6 option code": "XRails",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "1",
  //    "Attribute value translation": "One Cross Rail",
  //    "Apply to products(value)": "*"
  //  },
  //  {
  //    "V6 option code": "XRails",
  //    "Attribute translation": "",
  //    "Apply to products(attribute)": "",
  //    "Attribute value code": "2",
  //    "Attribute value translation": "Two Cross Rails",
  //    "Apply to products(value)": "*"
  //  }
  //]
  ////#region
}
